<template>
  <!-- Product Group Grade Form -->
  <div>
    <br />
    <div class="row ml-3">
      <div class="col-md-11">
        <!-- <p>Tracking of Product Status Grade</p> -->
        <div>
          <base-checkbox
            v-if="formSettings.allow_product_group_update == true"
            class="mb-3"
            v-model="menus.override_product_group"
            >Product Group</base-checkbox
          >
        </div>
        <base-input
          v-if="formSettings.allow_product_group_update == true"
          label="Product Group"
        >
          <a-select
            v-model="menus.product_group_id"
            showSearch
            placeholder="Select Product Group"
            :disabled="menus.override_product_group != true"
            optionFilterProp="children"
            style="width: 100%"
          >
            <a-select-option
              v-for="product_group_option in productGroupOptions"
              :key="product_group_option.id"
              :value="product_group_option.id"
              >{{ product_group_option.name }}</a-select-option
            >
          </a-select>
        </base-input>

        <base-checkbox class="mb-3" v-model="menus.override_product_grade"
          >Product Group Grade</base-checkbox
        >
        <div class="row">
          <div class="col">
            <base-input label="Date">
              <a-date-picker
                name="product_grade_effectivity_date"
                class="product_grade_field"
                :format="dateFormat"
                :disabled-date="disabledDate"
                v-model="product_grade.effectivity_date"
                :disabled="menus.override_product_grade != true"
                placeholder="Select date"
                @change="updateProductGradeEffectivityDate"
                required
              />
            </base-input>
          </div>
        </div>
        <div class="float-right">
          <button
            type="button"
            class="btn btn-sm btn-primary float-right"
            name="submit"
            @click="productGradeHandleAdd"
          >
            Add
          </button>
        </div>

        <br />
        <br />
      </div>

      <!-- product group grade table -->
      <div class="col-md-11">
        <a-table
          :columns="productGradeColumns"
          :dataSource="productGradeData"
          :pagination="false"
          :scroll="{ y: 400 }"
        >
        </a-table>
      </div>
      <!-- end product group grade table -->
    </div>
  </div>
  <!-- End of Product Group Grade Form -->
</template>

<script>
import { mapState } from "vuex";
import secureStorage from "../controllers/secureStorage.js";
import HTTPRequest from "../controllers/httpRequest.js";
import moment from "moment";

var component_x;
// product grade columns
const productGradeColumns = [
  {
    title: "Effectivity Date",
    dataIndex: "effectivity_date",
    scopedSlots: {
      customRender: "effectivity_date",
    },
  },
];
// end product grade columns

export default {
  data() {
    return {
      //  product grade data
      menus: {
        productGradeData: [],
      },
      override_product_group: false,
      override_product_grade: false,
      product_group_id: null,
      dateFormat: "YYYY/MM/DD",
      productGradeCount: 1,
      productGradeData: [],
      productGradeColumns,
      settingCode: null,
      product_grade: {
        key: null,
        level: 0,
        effectivity_date: null,
        status: "A",
      },
      productGroupOptions: [], // product group data
      formSettings: {},
    };
    // end product grade data
  },
  computed: {
    ...mapState([
      "currentProfile",
      "currentApiURL",
      "endPoint",
      "parameters",
      "categoriesOptions",
    ]),
  },

  mounted: async function () {
    component_x = this;
    component_x.settingCode = component_x.$attrs.settingCode;
    component_x.productGradeData = []; //product grade

    component_x.getProductGroupData(); // get product group option

    var userId = secureStorage.getItem("userId");
    var response;

    response = await HTTPRequest.getRequest(
      this.endPoint + "/user_settings?module_name=px&user_id=" + userId,
      null
    );
    var userSettings;
    if (response.data[0] != undefined) {
      userSettings = JSON.parse(response.data[0].settings_json);
    } else {
      userSettings = {};
    }

    component_x.formSettings = Object.assign({}, userSettings);
  },

  watch: {
    menus: {
      handler: async function () {
        this.product_group_id = this.menus.product_group_id;
        var configValues = {};
        configValues[this.settingCode] = this.menus;
        component_x.$emit("changeValue", configValues);
      },
      deep: true,
    },
  },

  methods: {
    moment,
    // get product group data method
    async getProductGroupData() {
      var product_group_data = await HTTPRequest.getRequest(
        this.endPoint + "product_groups/get_valid_product_groups",
        null
      );

      this.productGroupOptions = product_group_data;
    },

    updateProductGradeEffectivityDate(date) {
      if (date != null) {
        this.product_grade.effectivity_date =
          moment(date).format("MMMM DD, YYYY");
      }

      this.tableErrors = [];
    },

    disabledDate(current) {
      return current < moment().startOf("day");
    },

    productGradeHandleAdd: async function () {
      this.tableErrors = [];
      const product_grade = this.product_grade;
      const productGradeCount = this.productGradeCount;
      var last_effectivity_date;

      var last_product_grade = this.productGradeData.slice(-1)[0];
      if (last_product_grade != null) {
        // console.log(last_product_group.effectivity_date);
        last_effectivity_date = new Date(last_product_grade.effectivity_date);
        // console.log(last_effectivity_date, last_level);
      }

      // console.log(last_effectivity_date);

      if (!product_grade.effectivity_date) {
        this.tableErrors.push("Effectivity Date Required");
      }

      if (last_effectivity_date != null) {
        if (
          moment(product_grade.effectivity_date).isSameOrBefore(
            last_effectivity_date,
            "day"
          ) &&
          product_grade.effectivity_date != null
        ) {
          this.tableErrors.push(
            "Effectivity Date Cannot be before " +
              last_effectivity_date.toLocaleDateString()
          );
        }
      }

      if (this.tableErrors.length <= 0) {
        // console.log(last_level);
        product_grade.status = "A";
        product_grade.key = productGradeCount;
        this.productGradeData.push({ ...product_grade });
        this.menus.productGradeData.push({ ...product_grade });
        // console.log(product_group);
        this.productGradeCount = productGradeCount + 1;
        this.product_grade = [];
      } else {
        alert(this.tableErrors.join("\r\n"));
      }
    },
    // end of product group methods
  },
};
</script>